import {Component, Input, OnInit} from '@angular/core';
import {DocumentAttachment, IncidentResponse, ReferenceBookResponse, ReferenceBookType} from '@npck/af-frontend-api';
import {DictionaryHolderService} from 'projects/af/src/app/domain/dictionary-holder.service';
import {FileViewModel, mapToViewModel} from '../../../../components/files/file-preview/file-preview.component';

@Component({
    selector: 'af-documents-tab',
    templateUrl: './documents-tab.component.html',
    standalone: false,
})
export class DocumentsTabComponent implements OnInit {
    @Input() incident: IncidentResponse;
    allAttachments: AttachmentViewModel[] = [];
    commonInformationAttachments: AttachmentViewModel[];
    transactionsAttachments: TransactionAttachments[];

    constructor(private dictionaryHolderService: DictionaryHolderService) {
    }

    ngOnInit(): void {
        this.allAttachments = [];
        this.dictionaryHolderService.getReference(ReferenceBookType.ATTACHED_DOC)
            .subscribe(docTypes => {
                this.commonInformationAttachments =
                    this.incident.attachments?.map(attachment => this.mapToViewModel(attachment, docTypes));

                this.transactionsAttachments = this.incident.transactions.map(transaction => <TransactionAttachments>{
                        transactionId: transaction.id,
                        transactionAttachments: transaction.attachments
                            ?.map(filesWithDocumentType => this.mapToViewModel(filesWithDocumentType, docTypes)),
                    },
                );
            });
    }

    private mapToViewModel(filesWithDocumentType: DocumentAttachment, docTypes: ReferenceBookResponse[]): AttachmentViewModel {
        const attachments = mapToViewModel(filesWithDocumentType, docTypes);
        this.allAttachments.push(attachments);
        return attachments;
    }
}

export interface TransactionAttachments {
    transactionId: string;
    transactionAttachments: AttachmentViewModel[];
}

export interface AttachmentViewModel {
    documentType: string;
    files: FileViewModel[];
}
